import { AUTH_TYPES, TEMPLATE_CATEGORIES } from './constants.js'

export const hubspotTemplate = {
	id: 'hubspot',
	guid: '3fbb3f8b-dcf7-4a93-8a4d-7eaa6d473b9a',
	name: 'HubSpot',
	category: TEMPLATE_CATEGORIES.CRM,
	popularity: 'Most Popular',
	color: '#ff7a59',
	icon: 'mdi-hubspot',
	description: 'Connect to HubSpot CRM for contact management, deals tracking, and marketing automation.',
	features: ['OAuth2 Auth', 'Contact Sync', 'Deal Management', 'Email Marketing'],
	configFields: [
		{ name: 'apiKey', label: 'API Key', type: 'password', required: true, placeholder: 'Enter your HubSpot API key' },
		{ name: 'portalId', label: 'Portal ID', type: 'text', required: true, placeholder: 'Enter your HubSpot portal ID' }
	],
	endpoints: [
		{
			name: 'Create Contact',
			url: '{instance_url}/crm/v3/objects/contacts',
			method: 'POST',
			description: 'Create a contact in HubSpot',
			cassieObjectID: -3,
			incrementField: 'syrenisID',
			resetIncrementValue: false,
			fields: [
				{ name: 'SyrenisID', filter: '' },
				{ name: 'Forename', filter: '' },
				{ name: 'Surname', filter: '' }
			],
			requestBody: '{ "properties":{     "email":"[PLACEHOLDER_EMAIL1]",     "firstname":"[PLACEHOLDER_FORENAME]",     "lastname":"[PLACEHOLDER_SURNAME]"  } }',
			headers: [{ Name: 'Authorization', value:	'Bearer [APIKEY]' }],
			successResponses: [{ code: 204, message: '' }]
		},
		{
			name: 'Record Opt in',
			url: '{instance_url}/communication-preferences/v4/statuses/[PLACEHOLDER_EMAIL1]',
			method: 'POST',
			description: 'Update a contact\'s communication preferences to opt in',
			cassieObjectID: -5,
			incrementField: 'PreferenceID',
			resetIncrementValue: false,
			fields: [
				{ name: 'ChannelID', filter: '' },
				{ name: 'Email1', filter: '' },
				{ name: 'PreferenceID', filter: '' },
				{ name: 'ConsentValue', filter: '' },
				{ name: 'StatementText', filter: '' }
			],
			requestBody: '{ "subscriptionId": "[PLACEHOLDER_CHANNELID]",  "statusState": "[PLACEHOLDER_CONSENTVALUE]",  "legalBasis": "[LEGITIMATE_INTEREST_CLIENT]", "legalBasisExplanation": "[PLACEHOLDER_STATEMENTTEXT]", "channel": "EMAIL" }',
			headers: [{ Name: 'Authorization', value:	'Bearer [APIKEY]' }],
			successResponses: [{ code: 204, message: '' }]

		},
		{
			name: 'Unsubscribe',
			url: '{instance_url}/communication-preferences/v3/unsubscribe',
			method: 'POST',
			description: 'Update a contact\'s communication preferences to opt out',
			cassieObjectID: -5,
			incrementField: 'PreferenceID',
			resetIncrementValue: false,
			fields: [
				{ name: 'ChannelID', filter: '' },
				{ name: 'Email1', filter: '' },
				{ name: 'PreferenceID', filter: '' },
				{ name: 'ConsentValue', filter: '' }
			],
			requestBody: '{ "emailAddress":"[PLACEHOLDER_EMAIL1]","subscriptionId":"[PLACEHOLDER_CHANNELID]"}',
			headers: [{ Name: 'Authorization', value:	'Bearer [APIKEY]' }],
			successResponses: [{ code: 200, message: '' }]
		}
	],
	defaults: {
		endpointAddress: 'https://api.hubapi.com',
		authenticationUrl: 'https://app.hubspot.com/oauth/authorize',
		authenticationTypeId: AUTH_TYPES.API_KEY,
		frequencyInSeconds: 0,
		auth2Scope: 'contacts content reports timeline',
		notes: 'HubSpot CRM integration for comprehensive customer relationship management and marketing automation.'
	}
}
